(function(){
  var M = JSON.parse(document.getElementById('printhia-lp-compare-messages').textContent);
  var title=document.querySelector('[data-cmp-title]');
  var name=document.querySelector('[data-cmp-chat-name]');
  var meta=document.querySelector('[data-cmp-chat-meta]');
  var avatar=document.querySelector('[data-cmp-avatar]');
  var body=document.querySelector('[data-cmp-body]');
  var alertEl=document.querySelector('[data-cmp-alert-text]');
  var chat=document.querySelector('[data-cmp-chat]');
  if(!title||!body) return;
  if(chat && chat.dataset.lpCmpBound) return;
  if(chat) chat.dataset.lpCmpBound = '1';

  var scenarios = [
    {
      title:M.text_5,
      name:M.text_6,
      meta:'Mirka, Peter, ty',
      avatar:'D',
      day:M.text_7,
      msgs:[
        {a:'Peter',t:M.text_8,time:'20:14'},
        {a:'Mirka',t:M.text_9,time:'20:31'},
        {a:'Peter',t:M.text_10,time:'20:42'}
      ],
      typing:true,
      alert:M.text_11
    },
    {
      title:M.text_12,
      name:M.text_13,
      meta:'Lukáš, ty',
      avatar:'L',
      day:M.text_14,
      msgs:[
        {a:'Ivana',t:M.text_15,time:'18:02'},
        {a:'Lukáš',t:M.text_16,time:'18:15'},
        {a:'Ivana',t:M.text_17,time:'18:22'}
      ],
      typing:true,
      alert:M.text_18
    },
    {
      title:M.text_19,
      name:M.text_20,
      meta:'Paťka, Janka, Filip, ty',
      avatar:'S',
      day:'Sobota',
      msgs:[
        {a:'Paťka',t:M.text_21,time:'11:04'},
        {a:'Filip',t:M.text_22,time:'11:28'},
        {a:'Janka',t:M.text_23,time:'11:35'}
      ],
      typing:true,
      alert:M.text_24
    },
    {
      title:M.text_25,
      name:M.text_26,
      meta:'Anna, Juraj, ty',
      avatar:'K',
      day:M.text_27,
      msgs:[
        {a:'Anna',t:M.text_28,time:'09:12'},
        {a:'Juraj',t:M.text_29,time:'09:20'},
        {a:'Anna',t:M.text_30,time:'09:24'}
      ],
      typing:true,
      alert:M.text_31
    },
    {
      title:M.text_32,
      name:M.text_33,
      meta:M.text_34,
      avatar:'V',
      day:M.text_35,
      msgs:[
        {a:M.text_36,t:M.text_37,time:'19:45'},
        {a:'Ty',t:M.text_38,time:'19:52'},
        {a:M.text_39,t:M.text_40,time:'20:01'}
      ],
      typing:true,
      alert:M.text_41
    },
    {
      title:M.text_42,
      name:'Narodky · Lea 30',
      meta:'Tim, Kika, ty',
      avatar:'N',
      day:M.text_43,
      msgs:[
        {a:'Tim',t:M.text_44,time:'14:10'},
        {a:'Kika',t:M.text_45,time:'14:15'},
        {a:'Ty',t:M.text_46,time:'14:22'}
      ],
      typing:true,
      alert:M.text_47
    },
    {
      title:M.text_48,
      name:M.text_49,
      meta:'Jakub, Soňa, ty',
      avatar:'O',
      day:M.text_14,
      msgs:[
        {a:'Jakub',t:M.text_50,time:'21:02'},
        {a:'Soňa',t:M.text_51,time:'21:08'},
        {a:'Ty',t:M.text_52,time:'21:12'}
      ],
      typing:true,
      alert:M.text_53
    },
    {
      title:M.text_54,
      name:M.text_55,
      meta:'Miška, ty',
      avatar:'V',
      day:M.text_7,
      msgs:[
        {a:'Miška',t:M.text_56,time:'12:30'},
        {a:'Ty',t:M.text_57,time:'12:33'},
        {a:'Miška',t:M.text_58,time:'12:41'}
      ],
      typing:true,
      alert:M.text_59
    },
    {
      title:M.text_60,
      name:M.text_61,
      meta:'Manžel, ty',
      avatar:'B',
      day:'Sobota',
      msgs:[
        {a:'Ty',t:M.text_62,time:'10:15'},
        {a:'Manžel',t:M.text_63,time:'10:22'},
        {a:'Ty',t:M.text_64,time:'10:28'}
      ],
      typing:true,
      alert:M.text_65
    },
    {
      title:M.text_66,
      name:M.text_67,
      meta:M.text_68,
      avatar:'M',
      day:M.text_69,
      msgs:[
        {a:M.text_36,t:M.text_70,time:'16:20'},
        {a:M.text_71,t:M.text_72,time:'16:31'},
        {a:M.text_36,t:M.text_73,time:'16:40'}
      ],
      typing:true,
      alert:M.text_74
    },
    {
      title:M.text_75,
      name:M.text_76,
      meta:'Janka, Ondro, ty',
      avatar:'T',
      day:M.text_7,
      msgs:[
        {a:'Janka',t:M.text_77,time:'13:04'},
        {a:'Ondro',t:M.text_78,time:'13:09'},
        {a:'Ty',t:M.text_79,time:'13:14'}
      ],
      typing:true,
      alert:M.text_80
    },
    {
      title:M.text_81,
      name:M.text_82,
      meta:'Dávid, Nika, ty',
      avatar:'K',
      day:M.text_35,
      msgs:[
        {a:'Dávid',t:M.text_83,time:'18:45'},
        {a:'Nika',t:M.text_84,time:'18:52'},
        {a:'Ty',t:M.text_85,time:'19:01'}
      ],
      typing:true,
      alert:M.text_86
    }
  ];

  function render(s){
    title.textContent = s.title;
    name.textContent = s.name;
    meta.textContent = s.meta;
    avatar.textContent = s.avatar;
    alertEl.textContent = s.alert;
    var html = '<div class="lp-chat__day">'+s.day+'</div>';
    s.msgs.forEach(function(m){
      html += '<div class="lp-chat__msg lp-chat__msg--in"><span class="lp-chat__msg-author">'+m.a+'</span><div class="lp-chat__bubble">'+m.t+'</div><span class="lp-chat__time">'+m.time+'</span></div>';
    });
    if(s.typing) html += '<div class="lp-chat__typing" role="status" aria-label="Píše"><span></span><span></span><span></span></div>';
    body.innerHTML = html;
  }

  var i = Math.floor(Math.random()*scenarios.length);
  render(scenarios[i]);

  function next(){
    i = (i+1) % scenarios.length;
    chat.style.transition = 'opacity .45s ease, transform .45s ease';
    chat.style.opacity = '0';
    chat.style.transform = 'translateY(8px)';
    setTimeout(function(){
      render(scenarios[i]);
      chat.style.opacity = '1';
      chat.style.transform = 'translateY(0)';
    }, 480);
  }

  var _cmpTimer = null;
  function startCmp(){ if(_cmpTimer) return; _cmpTimer = setInterval(next, 9000); }
  function stopCmp(){ if(_cmpTimer){ clearInterval(_cmpTimer); _cmpTimer = null; } }
  startCmp();
  document.addEventListener('visibilitychange', function(){
    if(document.hidden) stopCmp(); else startCmp();
  });
})();